export const meta = {
  title: '营销群发：触达每一位说过“可以”的顾客',
  updatedAt: '2026-07-17',
  related: ['promotions', 'notifications'],
};

群发是您写一次、发给整个受众的推送通知——新促销、新套餐、节假日营业时间。它通过顾客从您的 QR 安装的那个应用送达他们的手机。

## 撰写

**营销**页左边是历史活动，右边是撰写器。一次活动包括标题、正文、可选的应用内跳转链接，以及受众。不想对着空白框发呆的话，**AI 起草**能把一句话的意图变成可编辑的标题和正文，改好再保存。

## 受众

四个现成受众：

- **全部顾客** —— 在您门店付过款的所有人。
- **近 30 天活跃** —— 您最热的客群。
- **银级及以上** —— 值得回馈的忠实顾客。
- **仅金级** —— VIP 专属优惠。

关于“全部”的一句实话：您能触达的名单，是在您这里完成过至少一次付费洗车的顾客——那一刻起对方才进入您的顾客列表。扫过您 QR 但从未洗过车的人是发不到的。

## “立即发送”到底做了什么

发送立刻执行，且每位接收者都要过三道为*他们*设的关卡：

- 已退订营销？**跳过。** 顾客的选择永远被尊重。
- 处于其免打扰时段（未改设置则为 22:00–08:00）？**跳过。** 营销绝不打穿免打扰时段。
- 手机上从未允许通知？**跳过** —— 根本没有可送达的通道。

发送完成后，您会收到逐项点名的摘要：已发送、已送达、因偏好跳过、因免打扰跳过、因无权限跳过、失败。所以当“全部顾客”只触达了名单的六成时，原因一目了然——没有悬念。

## 帮您远离麻烦的限制

- 每家企业**每天 10 次群发**。做真营销够用，做垃圾信息不够。
- 单次发送最多处理 **10,000 位接收者**。更大的受众会处理到上限为止，摘要会明说——绝不悄悄截断。
- 已发送的活动会被锁定，无法二次发送。想再发同样的内容，请新建一次活动。

## 诚实的边界

只有**立即发送**——还不能预约将来某个时间。推送是**唯一渠道**——没有 WhatsApp 或短信群发。而且一次群发只有**一种语言**：您输入的标题和正文就是每位接收者看到的原文，目前不会自动翻译。
